import { render, staticRenderFns } from "./ResultTranslation.vue?vue&type=template&id=95732dee&scoped=true"
import script from "./ResultTranslation.vue?vue&type=script&lang=js"
export * from "./ResultTranslation.vue?vue&type=script&lang=js"
import style1 from "./ResultTranslation.vue?vue&type=style&index=1&id=95732dee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95732dee",
  null
  
)

export default component.exports